import { useInfluencerUpdateDetailV2Query } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useAllTalentAgencyOrPartnerOptions, useQueryHelper } from '@anytag/shared-hooks';
import { Template } from './template';

interface EditInfluencerForOthersProps {
  influencerId: number;
}

export const EditInfluencerForOthers = ({ influencerId }: EditInfluencerForOthersProps) => {
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { allTalentAgenciesPartners, loading: fetchingTalentAgencyPartner } = useAllTalentAgencyOrPartnerOptions();
  const { data, loading, networkStatus } = useInfluencerUpdateDetailV2Query({
    fetchPolicy: 'network-only',
    variables: { pk: influencerId },
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/influencer/add' });
    }
  });

  const influencer = data?.influencerUpdateDetailV2 || null;

  return (
    <RenderDataWithFallback loading={(loading || fetchingTalentAgencyPartner) && networkStatus === 1}>
      {influencer ? <Template influencer={influencer} allTalentAgenciesPartners={allTalentAgenciesPartners} /> : null}
    </RenderDataWithFallback>
  );
};
